module.exports = __webpack_public_path__ + "static/media/door_right_front.c16af577.jpg";